/* eslint-disable @typescript-eslint/no-empty-object-type */
import { IBase } from '../ICommon';
import { IPagingDetails } from './IPagingDetails';

export interface IToolBOMInfo extends IBase {
  Id: number;
  ToolId: number;
  MaterialProductId?: string;
  ToolModel?: string;
  MaterialKatashiki1?: string;
  Category?: string;
  MaterialManufacturerCode?: string;
  TecmibizCode?: string;
}

export interface IToolBOMListVM extends IToolBOMInfo {}

export interface IToolBOMListResponseVM extends IPagingDetails {
  ToolBOM: IToolBOMListVM[];
}

export interface IToolBOMCSVImportResult {
  RowNo: number;
  ToolManagementNo: string | null;
  Success: boolean;
  Message: string;
}

export interface IToolBOMList extends IBase {
  Id: number;
  ToolId: number;
  MaterialProductId?: string;
  ToolModel?: string;
  MaterialKatashiki1?: string;
  Category?: string;
  MaterialManufacturerCode?: string;
  TecmibizCode?: string;
  isDelete: boolean;
  isEdit: boolean;
}

export interface IToolBomRelationInfo {
  MaterialProductId?: string;
  ToolName: string;
  ToolModel?: string;
  MaterialKatashiki1?: string;
  Category?: string;
  TeachmebizUrl?: string;
  ToolTeachmebizUrl?: string;
}

export interface IToolBomToolManagementInfo {
  ToolId: number;
  ToolManagementNo: string;
  ToolType: number;
  UsageStatus: number;
  OwnerFactoryId?: number | null;
  LoanFactoryId?: number | null;
  LoanRecord?: number | null;
  InspectionStatus: number | null;
  InspectionCycle?: number | null;
  InspectionFormat: number;
  CalibrationExpiryDate: string | null;
  CalibrationStatus: number | null;
  DisposalDate: string | null;
  // Wire format: a JSON array of process names, a legacy single plain process name, or null.
  // See process-used-helper.ts.
  ProcessUsed?: string | null;
  MountedTools?: IToolBomToolManagementInfo[];
}

// Enum for ToolBomUsageInfoDetails.State - the lifecycle state of a tool's usage on a tray.
export enum ToolBomUsageStateEnum {
  Start = 1,
  Pause = 2,
  Complete = 3,
  NonConformity = 4,
  Release = 5,
}

// Enum for ToolBomUsageInfoDetails.Mode - whether the operator was working in single or batch mode.
export enum ToolBomUsageModeEnum {
  Single = 1,
  Batch = 2,
}

// Matches the ToolBomUsageInfo API request shape - one row per (TrayId x ToolManagementNo) pair.
export interface IToolBomUsageInfoDetail {
  Id: number;
  FactoryId: string;
  TrayId: string;
  ProcessId: number;
  ToolManagementNo: string;
  ToolModel: string;
  OperatorUserId: number;
  Duration: number;
  State: ToolBomUsageStateEnum;
  Mode: ToolBomUsageModeEnum;
  CreatedBy: number;
  UpdatedBy: number;
}

export interface IValidateBomToolStatusResult {
  ToolManagementNo: string;
  MainUnitManagementNo: string | null;
}
